import * as THREE from 'three';
import { create } from 'zustand';

// Where the world station puts the sun; read every frame while it is on.
export const sun = {
  direction: new THREE.Vector3(0, 1, 0),
  target: new THREE.Vector3(),
  // half the side of the square the shadow map covers
  radius: 80,
  intensity: 3,
  color: new THREE.Color('#fff4e0'),
};

// While on, the sun replaces the warm key light and is the only shadow caster in the tour.
export const useSunStore = create<{ on: boolean; setOn: (on: boolean) => void }>((set) => ({
  on: false,
  setOn: (on) => set((s) => (s.on === on ? s : { on })),
}));
